export default __webpack_public_path__ + "static/media/history-log.36e6fb9e.svg";